import DeleteModal from '@Components/Modal/DeleteModal';
import { useDeleteReport } from '@Domains/Reports';
import { useDisclosure } from '@hooks/useDisclosure';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { Alert, Box, Button, Snackbar } from '@mui/material';
import { useState } from 'react';

type DeleteReportButtonProps = {
  id?: number;
  startOperatingYear?: number;
  endOperatingYear?: number;
  refetch?: () => void;
  isPublished: boolean;
};

const DeleteReportButton = (props: DeleteReportButtonProps) => {
  const {
    id,
    endOperatingYear,
    startOperatingYear,
    refetch,
    isPublished = false,
  } = props;
  const [opened, { open, close }] = useDisclosure();

  const [openedSnackbar, { open: openSnackbar, close: closeSnackbar }] =
    useDisclosure();

  const [snackbarMessage, setSnackbarMessage] = useState<string>('');

  const [{ error }, executeDeleteReport] = useDeleteReport(Number(id));

  const handleDelete = async () => {
    try {
      await executeDeleteReport();
      refetch?.();
      setSnackbarMessage('ลบรายงานสำเร็จ');
      openSnackbar();
    } catch (error) {
      console.error('Failed to delete report:', error);
      setSnackbarMessage('เกิดข้อผิดพลาดในการลบรายงาน');
      openSnackbar();
    }
  };

  const topic = `แบบ CVUP ${
    endOperatingYear
      ? `${startOperatingYear} - ${endOperatingYear}`
      : startOperatingYear
  }`;

  return (
    <Box>
      <Button
        color="inherit"
        startIcon={<DeleteOutlinedIcon />}
        onClick={open}
        disabled={isPublished}
      >
        ลบรายงาน
      </Button>

      <DeleteModal
        opened={opened}
        close={close}
        confirm={handleDelete}
        topic={topic}
      />

      <Snackbar
        open={openedSnackbar}
        autoHideDuration={2000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          severity={error ? 'error' : 'success'}
          onClose={closeSnackbar}
          sx={{
            alignItems: 'center',
            marginBottom: 6,
            '.MuiAlert-icon': { py: 1 },
            '.MuiAlert-message': { py: 1 },
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DeleteReportButton;
